export default __webpack_public_path__ + "static/userDummy3-65e4e8d2b5a143d1dc35714b4d5d6469.jpg";